import { Injectable } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { UserChangePasswordFormService } from '@spartacus/organization/administration/components';
import { CustomFormValidators } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class UIGUserChangePasswordFormService extends UserChangePasswordFormService {
  protected build() {
    const form = new UntypedFormGroup({});
    form.setControl('customerId', new UntypedFormControl(''));
    form.setControl(
      'password',
      new UntypedFormControl('', [
        Validators.required,
        ...CustomFormValidators.passwordValidators,
      ]),
    );
    form.setControl(
      'confirmPassword',
      new UntypedFormControl('', [
        Validators.required,
        ...CustomFormValidators.passwordValidators,
      ]),
    );
    form.setValidators(
      CustomFormValidators.passwordsMustMatch('password', 'confirmPassword'),
    );
    this.form = form;
  }
}
